import {Component, computed, input} from '@angular/core';
import {IconsComponent} from '../../icons/icons.component';

@Component({
  selector: 'app-step',
  imports: [
    IconsComponent
  ],
  templateUrl: './step.component.html',
  styleUrl: './step.component.css',
  host: {
    '[class]': 'liClass()'
  }
})
export class StepComponent {
  icon = input.required<string>();
  label = input<string>();
  active = input<boolean>(false);

  liClass = computed(() => {
    const baseClasses = 'flex items-center w-full gap-2';
    const marginClass = 'first:ms-0 ms-2';
    const connectorClass = 'after:content-[\'\'] after:w-full after:h-[1px] after:border-b after:border-gray-300 after:border-[1px] after:inline-block dark:after:border-gray-100 last:after:hidden';

    return `text-white ${baseClasses} ${marginClass} ${connectorClass}`;
  });

  spanClass = computed(() => {
    const baseClasses = 'flex items-center justify-center w-6 h-6 rounded-full shrink-0';

    if (this.active()) {
      return `${baseClasses} bg-brand`;
    }

    return `${baseClasses} bg-gray-400 dark:bg-gray-700`;
  });

  stepNameClass = computed(() => {
    let statusClass = 'text-gray-default';

    if (this.active()) {
      statusClass = 'text-brand';
    }

    return `whitespace-nowrap text-sm ${statusClass}`;
  });
}
